import React from 'react';

// Champ de formulaire avec label (réutilisé par les filtres et le builder).
export const Field = ({ label, children }) => (
  <div>
    <label className="block text-[10px] uppercase tracking-wider text-[#687175] mb-1">{label}</label>
    {children}
  </div>
);

export default Field;
